import { combineReducers } from 'redux';
import user from './User/user'
import excel from './Excel/excel'
import settings from './Settings/settings'


const rootReducer = combineReducers({
    user,
    excel,
    settings
});


export default rootReducer;